module.exports = __webpack_public_path__ + "/login_ui/img/td-caa2b3731d67a36c52948a5406db2622.svg";